import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { SoldToAddress } from "@dana/Types/ApiModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext, useEffect, useState } from "react";
import { css } from "styled-components";

export interface OrderDetailsShippingAddressStyles {
    titleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
    wrapper?: InjectableCss;
}

export const shippingAddressStyles: OrderDetailsShippingAddressStyles = {
    wrapper: {
        css: css`
            padding-bottom: 0;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
            padding-top: 10px;
        `,
    },
};

const styles = shippingAddressStyles;

const OrderDetailsShippingAddress: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    const soldToObj: SoldToAddress | undefined = order?.properties?.soldToAddress
        ? JSON.parse(order.properties.soldToAddress)
        : undefined;

    const hasShippingAddress = order.fulfillmentMethod === FulfillmentMethod.Ship || !order.fulfillmentMethod;

    const [shipToText, setShipToText] = useState("Ship To");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get("IsAnnualReturnsOrder") === "true") {
            setShipToText("Ship From");
        }
    }, []);

    return (
        <>

            <StyledWrapper {...styles.wrapper} data-test-selector="orderDetailShippingInformation">
                <Typography {...styles.titleText} className="text-body-md">
                    {translate("")}
                    {`${translate(shipToText)}: ${order?.customerSequence}`}
                </Typography>
                <AddressInfoDisplay
                    companyName={order.stCompanyName}
                    address1={order.stAddress1}
                    address2={order.stAddress2}
                    city={order.shipToCity}
                    state={order.shipToState}
                    postalCode={order.shipToPostalCode}
                    country={order.stCountry}
                    extendedStyles={styles.addressDisplay}
                />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShippingAddress,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
